import { Button } from 'components/button';
import { CarrelloDialog } from 'features/carrello/carrelloDialog';
import { CarrelloDialogVenditaFailedProps } from 'features/carrello/carrelloDialogVenditaFailed';
import styles from './CarrelloDialogVenditaFailed.module.scss';
import { useAppDispatch } from 'lib/centralStore';
import { useGetLabelsByKeys } from 'hooks/useLingUI';
import { venditaAlertFailedOpenChange } from 'features/carrello/carrelloSlice';

export const CarrelloDialogVenditaFailed = ({ error, ...props }: CarrelloDialogVenditaFailedProps) => {
  const dispatch = useAppDispatch();
  const [titleLabel, primaryButtonLabel] = useGetLabelsByKeys([
    'vendita-failed-dialog-title',
    'vendita-failed-dialog-primary-button',
  ])!;
  return (
    <CarrelloDialog {...props} type={'warning'} title={titleLabel} text={error}>
      <Button
        visualizationType={'primary'}
        size={'medium'}
        onClick={() => dispatch(venditaAlertFailedOpenChange(false))}
        className={styles.button}
      >
        {primaryButtonLabel}
      </Button>
    </CarrelloDialog>
  );
};